/* Lekka przeglądarka zdjęć (dialog): galerie na kartach produktu (a[data-fancybox]) oraz zdjęcia z atrybutem data-evm-zoom
   (np. karuzela „Galeria realizacji” na głównej — klik powiększa zdjęcie, nie wyprowadza ze strony). Inne galerie Fancybox mają
   własne wiązanie. Zdjęcia grupuje wartość atrybutu (data-fancybox albo data-evm-zoom); klony karuzeli są pomijane.
   Style ładuje ten plik sam (assets/evm-lightbox.css), bez dokładania CSS do układu strony. */
(function () {
  'use strict';

  var selector = '.product a[data-fancybox], a[data-evm-zoom]';
  var cssHref = document.currentScript && document.currentScript.src ? document.currentScript.src.replace('evm-product-lightbox.js', 'evm-lightbox.css') : '';
  if (cssHref && !document.querySelector('link[data-evm-lightbox-css]')) {
    var cssLink = document.createElement('link');
    cssLink.rel = 'stylesheet';
    cssLink.href = cssHref;
    cssLink.setAttribute('data-evm-lightbox-css', '');
    document.head.appendChild(cssLink);
  }
  var dialog;
  var photo;
  var counter;
  var zoomButton;
  var slides = [];
  var index = 0;
  var generation = 0;
  var zoom = 1;
  var offsetX = 0;
  var offsetY = 0;
  var origin = null;
  var pointers = new Map();
  var gesture = null;
  var labels = (document.documentElement.lang || '').toLowerCase().startsWith('en')
    ? { title: 'Product photos', close: 'Close photos', prev: 'Previous photo', next: 'Next photo', zoom: 'Zoom image', reduce: 'Reduce image' }
    : { title: 'Zdjęcia produktu', close: 'Zamknij zdjęcia', prev: 'Poprzednie zdjęcie', next: 'Następne zdjęcie', zoom: 'Powiększ zdjęcie', reduce: 'Zmniejsz zdjęcie' };

  function makeButton(className, label, text) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = className;
    button.setAttribute('aria-label', label);
    button.textContent = text;
    return button;
  }

  function ensureDialog() {
    if (dialog) return;
    dialog = document.createElement('dialog');
    dialog.className = 'evm-product-lightbox';
    dialog.setAttribute('aria-label', labels.title);
    dialog.setAttribute('aria-modal', 'true');
    var top = document.createElement('div');
    top.className = 'evm-product-lightbox__top';
    counter = document.createElement('span');
    counter.className = 'evm-product-lightbox__counter';
    counter.setAttribute('aria-live', 'polite');
    zoomButton = makeButton('evm-product-lightbox__button', labels.zoom, '+');
    var close = makeButton('evm-product-lightbox__button evm-product-lightbox__close', labels.close, '×');
    top.append(counter, zoomButton, close);
    var stage = document.createElement('div');
    stage.className = 'evm-product-lightbox__stage';
    photo = document.createElement('img');
    photo.className = 'evm-product-lightbox__photo';
    photo.alt = '';
    photo.draggable = false;
    stage.append(photo);
    var previous = makeButton('evm-product-lightbox__arrow evm-product-lightbox__prev', labels.prev, '‹');
    var next = makeButton('evm-product-lightbox__arrow evm-product-lightbox__next', labels.next, '›');
    dialog.append(top, stage, previous, next);
    document.body.append(dialog);

    close.addEventListener('click', function () { dialog.close(); });
    previous.addEventListener('click', function () { show(index - 1); });
    next.addEventListener('click', function () { show(index + 1); });
    zoomButton.addEventListener('click', function () { setZoom(zoom > 1 ? 1 : 2); });
    photo.addEventListener('dblclick', function () { setZoom(zoom > 1 ? 1 : 2); });
    dialog.addEventListener('click', function (event) { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') { event.preventDefault(); show(index + 1); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); show(index - 1); }
    });
    dialog.addEventListener('close', function () {
      generation++;
      pointers.clear();
      photo.removeAttribute('src');
      slides = [];
      if (origin && origin.isConnected) origin.focus({ preventScroll: true });
      origin = null;
    });

    stage.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
      stage.setPointerCapture(event.pointerId);
      if (pointers.size === 1) gesture = { x: event.clientX, y: event.clientY, offsetX: offsetX, offsetY: offsetY, moved: false };
      if (pointers.size === 2) {
        var pair = Array.from(pointers.values());
        gesture = { pinch: true, distance: Math.hypot(pair[0].x - pair[1].x, pair[0].y - pair[1].y), zoom: zoom };
      }
    });
    stage.addEventListener('pointermove', function (event) {
      if (!pointers.has(event.pointerId)) return;
      pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
      if (pointers.size === 2 && gesture && gesture.pinch) {
        var pair = Array.from(pointers.values());
        setZoom(Math.max(1, Math.min(3, gesture.zoom * Math.hypot(pair[0].x - pair[1].x, pair[0].y - pair[1].y) / Math.max(1, gesture.distance))));
      } else if (pointers.size === 1 && gesture && !gesture.pinch && zoom > 1) {
        offsetX = gesture.offsetX + event.clientX - gesture.x;
        offsetY = gesture.offsetY + event.clientY - gesture.y;
        applyTransform();
      }
    });
    function finishPointer(event) {
      if (!pointers.has(event.pointerId)) return;
      pointers.delete(event.pointerId);
      if (!pointers.size && gesture && !gesture.pinch && zoom === 1) {
        var dx = event.clientX - gesture.x;
        var dy = event.clientY - gesture.y;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.3) show(index + (dx < 0 ? 1 : -1));
      }
      if (pointers.size === 1) {
        var remaining = Array.from(pointers.values())[0];
        gesture = { x: remaining.x, y: remaining.y, offsetX: offsetX, offsetY: offsetY };
      } else if (!pointers.size) gesture = null;
    }
    stage.addEventListener('pointerup', finishPointer);
    stage.addEventListener('pointercancel', finishPointer);
  }

  function applyTransform() {
    photo.style.transform = 'translate3d(' + offsetX + 'px,' + offsetY + 'px,0) scale(' + zoom + ')';
  }

  function setZoom(value) {
    zoom = value;
    if (zoom === 1) offsetX = offsetY = 0;
    applyTransform();
    zoomButton.textContent = zoom > 1 ? '−' : '+';
    zoomButton.setAttribute('aria-label', zoom > 1 ? labels.reduce : labels.zoom);
  }

  function resizeUrl(url, width) {
    try {
      var parsed = new URL(url, location.href);
      if (parsed.pathname.indexOf('/cdn/shop/') !== -1) parsed.searchParams.set('width', String(width));
      return parsed.href;
    } catch (_) { return url; }
  }

  function show(nextIndex) {
    if (!slides.length) return;
    index = (nextIndex + slides.length) % slides.length;
    var item = slides[index];
    var token = ++generation;
    setZoom(1);
    counter.textContent = (index + 1) + ' / ' + slides.length;
    var thumbnail = item.querySelector('img');
    photo.alt = (thumbnail && thumbnail.alt) || (document.querySelector('.product__title h1') || {}).textContent || labels.title;
    var thumbSrc = thumbnail ? thumbnail.currentSrc || thumbnail.src : '';
    /* miniatura jeszcze nie wczytana (przezroczysty znacznik data:) nie może być podglądem */
    var readyPreview = thumbnail && thumbnail.complete && thumbnail.naturalWidth > 20 && !/^data:/.test(thumbSrc) ? thumbSrc : '';
    var previewWidth = Math.min(1400, Math.max(660, Math.round(innerWidth * devicePixelRatio)));
    photo.src = readyPreview || resizeUrl(item.href, previewWidth);
    var highResolution = new Image();
    highResolution.decoding = 'async';
    highResolution.src = item.href;
    highResolution.decode().then(function () {
      if (token === generation && dialog.open) photo.src = highResolution.src;
    }).catch(function () {});
  }

  document.addEventListener('click', function (event) {
    var anchor = event.target instanceof Element ? event.target.closest(selector) : null;
    if (!anchor || event.defaultPrevented || typeof HTMLDialogElement === 'undefined' || !HTMLDialogElement.prototype.showModal || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    event.stopPropagation();
    ensureDialog();
    origin = anchor;
    var gallery = anchor.closest('media-gallery');
    slides = Array.from(gallery ? gallery.querySelectorAll('a[data-fancybox]') : document.querySelectorAll(selector))
      .filter(function (item) { return item.dataset.fancybox === anchor.dataset.fancybox && item.dataset.evmZoom === anchor.dataset.evmZoom && !item.closest('.is-clone'); });
    index = slides.indexOf(anchor);
    /* klik w klon karuzeli → to samo zdjęcie w oryginale */
    if (index < 0) index = slides.findIndex(function (item) { return item.href === anchor.href; });
    if (index < 0) return;
    dialog.showModal();
    show(index);
    dialog.querySelector('.evm-product-lightbox__close').focus({ preventScroll: true });
  }, true);
})();
